import { render, staticRenderFns } from "./SignUpPartner.vue?vue&type=template&id=4d227f85&scoped=true"
import script from "./SignUpPartner.vue?vue&type=script&lang=js"
export * from "./SignUpPartner.vue?vue&type=script&lang=js"
import style0 from "./SignUpPartner.vue?vue&type=style&index=0&id=4d227f85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d227f85",
  null
  
)

export default component.exports